class FeaturedCollection extends HTMLElement {
  constructor() {
    super();
    this.featuredContainer = this;
    this.navlinks = this.querySelectorAll('.sec-ProductCarousel_NavLink')
    this.sliderComponent = this.querySelectorAll('.sec-ProductCarousel')

    this.navlinks.forEach((link) => {
      link.addEventListener('click', this.activateTab.bind(this))
    })
  }

  activateTab({ target }) {
    const { index } = target.dataset

    this.navlinks.forEach((link) => {
      if (link.dataset.index === index) {
        link.classList.add('is-active')
      } else {
      link.classList.remove('is-active')
      }
    }
    )

    this.activateCarousel(index)
  }

  activateCarousel(activeIndex) {
    this.sliderComponent.forEach((item) => {
      if (item.dataset.index === activeIndex) {
        item.removeAttribute('aria-hidden')

      } else {
        item.setAttribute('aria-hidden', true)
      }
    })
  }
}

customElements.define('featured-collection', FeaturedCollection);
